import styled from 'styled-components';

export const HeaderListDownloadDataStyled = styled.div`
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    > img {
      margin-left: -4px;
      border-radius: 6px;
    }
    h2 {
      font-size: 20px;
      font-family: 'Inter';
      margin: 0 0 0 10px;
    }
  }
`;
